import axios from 'axios';
import camelcaseKeys from 'camelcase-keys';
import qs from 'qs';

export function search(path, query, otherParams) {
  const params = {
    limit: 10,
    q: query,
    ...otherParams
  };

  return axios.get(`${path}?${qs.stringify(params)}`).then((response) => {
    return camelcaseKeys(Object.values(response.data)[0], { deep: true });
  });
}
